import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import DocumentTile from '../DocumentTile/DocumentTile.js';

import { IDocumentTilesConfiguration, IDocumentTilesProps, IDocumentTilesState } from './models/index.js';
import Wrapper from './styledComponents/Wrapper.js';
import { DOCUMENT_TILES_CATEGORY_KEY, DOCUMENT_TILES_COMPONENT_KEY } from './DocumentTiles.meta.js';

export class DocumentTiles extends ComponentBase<
	IDocumentTilesProps,
	IDocumentTilesState,
	IDocumentTilesConfiguration
> {
	categoryKey = DOCUMENT_TILES_CATEGORY_KEY;
	componentKey = DOCUMENT_TILES_COMPONENT_KEY;

	constructor(props: IDocumentTilesProps) {
		super(props);
	}
	render() {
		const { className, tiles = [], onDocumentClick } = this.props;
		return (
			<Wrapper className={className}>
				{tiles.map((tile, index) => {
					// Propagate onClick event down to the tile from the tiles props
					if (!tile.onClick && onDocumentClick) {
						tile.onClick = onDocumentClick;
					}
					return <DocumentTile key={`documentTile${index}`} {...tile} />;
				})}
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(
	observer(DocumentTiles),
	DOCUMENT_TILES_CATEGORY_KEY,
	DOCUMENT_TILES_COMPONENT_KEY,
);
